import {
  AfterViewInit,
  Component,
  EventEmitter,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { AuthFacadeService } from '@ib-core/services/auth-facade.service';
import { ModalsService } from '@ib-core/services/modals.service';
import { AbstractBaseComponent } from '@ib-shared/abstract/abstract-base';
import { IAuthUser } from '@ib-shared/interfaces/auth-user.intf';
import { takeUntil } from 'rxjs';

@Component({
  selector: 'ib-dashboard-credit-account-modal',
  templateUrl: './dashboard-credit-account-modal.component.html',
  styleUrls: ['./dashboard-credit-account-modal.component.scss'],
})
export class DashboardCreditAccountModalComponent
  extends AbstractBaseComponent
  implements AfterViewInit
{
  public modalRef: MatDialogRef<TemplateRef<HTMLElement>>;
  public currency: string;
  public ibans = {
    eur: 'IE05BARC99021244513404',
    gbp: 'GB74BARC20035373796558',
    usd: 'IE48BARC99021244513406',
  };
  @ViewChild('modalTmpl') modalTmpl: TemplateRef<HTMLElement>;

  @Output() closeMe = new EventEmitter<void>();
  get authUser(): IAuthUser {
    return this.authFacadeS.authUser;
  }
  reference: string;
  constructor(
    private modalsS: ModalsService,
    private authFacadeS: AuthFacadeService,
  ) {
    super();
  }

  get iban(): string {
    return this.authUser?.bankCurrency
      ? this.ibans[this.authUser.bankCurrency.toLowerCase()]
      : '';
  }

  ngAfterViewInit(): void {
    const id = this.authFacadeS.authUser.id as string;
    this.reference = id.slice(-7);
    setTimeout(() => {
      this.openModal();
    });
  }
  openModal(): void {
    this.modalRef = this.modalsS.openModal(this.modalTmpl, {
      maxWidth: '95vw',
      maxHeight: '95vh',
    });
    this.modalRef
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.closeMe.emit();
      });
  }

  todo(): void {
    //
  }
}
